import { useEffect, useRef } from 'react';

import type { DemoChatMessage } from '../model/message';
import MessageItem from './MessageItem';

interface Props {
  messages: DemoChatMessage[];
  isLoading?: boolean;
}

const MessageList = ({ messages, isLoading = false }: Props) => {
  const listRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const root = listRef.current;
    if (!root || messages.length === 0) return;
    root.scrollTo({ top: root.scrollHeight, behavior: 'smooth' });
  }, [messages.length]);

  if (!messages.length && !isLoading) {
    return (
      <div className="flex min-h-0 flex-1 items-center justify-center bg-bg-surface px-4 py-8 text-lg font-semibold text-text-subtle">
        Aún no hay mensajes. Envía uno para empezar la conversación.
      </div>
    );
  }

  return (
    <div
      ref={listRef}
      className="flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto overscroll-contain bg-bg-surface p-4"
    >
      {messages.map((message) => (
        <MessageItem key={message.id} message={message} />
      ))}
    </div>
  );
};

export default MessageList;
